import { employeeEndpoints } from './employee';
import { dashboardEndpoints } from './dashboard';
import { taskEndpoints } from './task';
import { projectEndpoints } from './project';
import { tenantEndpoints, tenanFolderFileEndpoints } from './tenant';
import { documentsEndpoint } from './documents';
import { notificationsEndpoints } from './notfication';
import { CONFIG } from 'src/config-global';
import { employeeFileEndpoints } from './employee-files';
import { teammemberEndpoints } from './team-members';
import { setUpEndpoints } from './setup';
import { workflowEndpoints } from './workflow';
import { commentsEndpoints } from './comment';
import { VendorEndpoints } from './vendors';
import { ClientEndpoints } from './clients';
import { loyaltyEndpoints } from './loyalty';

import { meetingsEndpoint } from './meetings';
import { reminderEndpoints } from './reminder';
import { followupEndpoints } from './followup';
import { timesheetEndpoints } from './timesheet';

export const apiEndpoints = {
  auth: {
    signIn: `${CONFIG.tenant}/api/Login/SignIn`,
    refreshToken: `${CONFIG.tenant}/api/Login/RefreshToken`,
    signInUaePass: `${CONFIG.tenant}/api/Login/UaePassWebAuth`,
    forgetpw: `${CONFIG.tenant}/api/Login/forgetPassword`,
    verifyEmail: `${CONFIG.tenant}/api/Login/VerifyEmployeeEmail`,
    resetPassword: `${CONFIG.tenant}/api/Login/resetPassword`,
    resendOTP: `${CONFIG.tenant}/api/Login/SendVerificationEmail`,
    logOut: `/api/LoginAuth/Logout`,
  },
  employee: employeeEndpoints,
  dashboard: dashboardEndpoints,
  tasks: taskEndpoints,
  projects: projectEndpoints,
  tenants: tenantEndpoints,
  tenantsEmp: tenanFolderFileEndpoints,
  employeeFiles: employeeFileEndpoints,
  teams: teammemberEndpoints,
  document: documentsEndpoint,
  notifications: notificationsEndpoints,
  setup: setUpEndpoints,
  workflow: workflowEndpoints,
  comments: commentsEndpoints,
  vendor: VendorEndpoints,
  client: ClientEndpoints,
  loyalty: loyaltyEndpoints,
  meetings: meetingsEndpoint,
  reminder: reminderEndpoints,
  followup: followupEndpoints,
  timesheet: timesheetEndpoints,
};
